import './styles/index.scss';

import AuctionsNewFeatureModal from '@shared/components/AuctionsNewFeatureModal';
import Ethnio from '@shared/components/Ethnio';
import useAdobeTarget from '@shared/hooks/useAdobeTarget';
import appLogger from '@shared/logging/appLogger';
import AuthProvider, { IAuthService, useAuth } from '@shared/providers/AuthProvider';
import { AdobeSiteSection } from '@shared/types/adobe-analytics';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';

import FAQ from './components/faq';
import FindLocation from './components/find-location';
import HeroContent from './components/HeroContent';
import HowItWorks from './components/how-it-works';
import PromotionsSlider from './components/promotions-slider';
import ReasonsToBelieve from './components/reasons-to-believe';

export interface HomePageProps {
    authService: IAuthService;
}
const App = ({ authService }: HomePageProps) => {
    return (
        <AuthProvider authService={authService}>
            <InnerApp />
        </AuthProvider>
    );
};
const InnerApp = (): JSX.Element => {
    useAdobeTarget();
    const { getUser } = useAuth();

    useEffect(() => {
        const user = getUser();
        const pageName = `${AdobeSiteSection.Homepage}${user ? ':Authenticated' : ''}`;

        appLogger.logPageView({
            name: pageName,
            uri: `${window.location.href}`,
            refUri: `${document.referrer}`,
            properties: {
                ruleName: 'auctionsPageLoad',
            },
        });
    }, [getUser]);

    const CenterContent = ({ children }) => <div className="center-content-block">{children}</div>;

    const queryConfig = {
        defaultOptions: {
            queries: {
                retry: false,
                refetchOnMount: false,
                refetchOnReconnect: false,
                refetchOnWindowFocus: false,
            },
        },
    };

    const queryClient = new QueryClient(queryConfig);
    return (
        <QueryClientProvider client={queryClient}>
            <Ethnio code={88885} />
            <div className="host">
                <HeroContent />
                <CenterContent>
                    <HowItWorks />
                </CenterContent>
                <PromotionsSlider />
                <ReasonsToBelieve />
                <FindLocation />
                <FAQ />
                <AuctionsNewFeatureModal remoteName="home" />
            </div>
        </QueryClientProvider>
    );
};

export default App;
